var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.announcements.length)?_c('div',{staticClass:"d-print-none"},_vm._l((_vm.announcements),function(announcement,index){return _c('div',{key:index,class:['alert mb-0 p-2 alert-announcement', 'alert-' + announcement.announcementTheme ],domProps:{"innerHTML":_vm._s(announcement.announcementMessage)}})}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }